import MainLayout from 'components/layout/MainLayout';
import { Fragment, ReactElement } from 'react';

interface Dashboard2026Props {
  children: ReactElement;
  variant?: string | undefined;
}

const Dashboard2026 = (props: Dashboard2026Props) => {
  if (props.children && props.variant !== 'V1') {
    // Allow our default branch to always show the existing dashboard
    return props.children;
  }

  // Allow the new dashboard to appear outside of plasmic's catchall when the time comes. When props.children is set,
  // the component will be inside plasmic's CatchAll which provides the MainLayout. Otherwise, we have to provide our
  // own
  const Wrapper = props.children ? Fragment : MainLayout;
  return (
    <Wrapper limitItemWidths noHeaderDropShadow>
      <div
        className="aboutUsTypographyReset"
        style={{
          // Make the component go "full-bleed" in plasmic's container. We can probably remove this once the dashboard
          // page lives outside of plasmic
          width: '100%',
          gridColumn: '1 / 8',
          // Make the component be at least one-screen-height tall, like the plasmic variant. We can probably remove this
          // once the dashboard page lives outside of plasmic
          minHeight: '100vh',
        }}
      >
        New dashboard goes here
      </div>
    </Wrapper>
  );
};

export default Dashboard2026;
